import React from 'react'
import {Helmet} from 'react-helmet'

const environment = process.env.ENVIRONMENT
const CookieBanner: React.FC = () => {
  if (environment === 'development' || environment === 'staging') {
    return (
      <Helmet>
        <script
          type="text/javascript"
          src="https://cdn.cookielaw.org/consent/327d2cba-7b4d-4d0b-99bd-ab1d33b856c2-test/OtAutoBlock.js"
        />
        <script
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          type="text/javascript"
          charSet="UTF-8"
          data-domain-script="327d2cba-7b4d-4d0b-99bd-ab1d33b856c2-test"
        />
        <script type="text/javascript">
          {'function OptanonWrapper() {}'}
        </script>
      </Helmet>
    )
  }
  return (
    <Helmet>
      <script
        type="text/javascript"
        src="https://cdn.cookielaw.org/consent/327d2cba-7b4d-4d0b-99bd-ab1d33b856c2/OtAutoBlock.js"
      />
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script="327d2cba-7b4d-4d0b-99bd-ab1d33b856c2"
      />
      <script type="text/javascript">
        {'function OptanonWrapper() {}'}
      </script>
    </Helmet>
  )
}

export default CookieBanner
